import { computed } from 'vue';
import { useI18n } from './i18n.composable';

export const useSteeringWheelInformation = (steeringWheelCode?: string) => {
  const { t } = useI18n();
  const translationKeyLeft = 'dcp.vehicleSteeringWheel.left';
  const translationKeyRight = 'dcp.vehicleSteeringWheel.right';
  const translationKeyLabel = 'dcp.vehicleSteeringWheel.label';

  const steeringWheelPosition = computed<string | undefined>(() => {
    if (steeringWheelCode === 'LHD') {
      return t(translationKeyLeft);
    } else if (steeringWheelCode === 'RHD') {
      return t(translationKeyRight);
    }

    return undefined;
  });

  return {
    steeringWheelPosition,
    translationKeyLeft,
    translationKeyRight,
    translationKeyLabel,
  };
};
